export default "__VITE_PUBLIC_ASSET__c4f88dff__"